<!--
  创建时间：2024/8/21 16:58
  创建人：toyehuang
  文件描述：LoginEntry 登录入口
-->

<template>
  <div class="login-entry">
    <div class="login-entry-head">
      <h3>登录入口</h3>
    </div>
    <ul class="f-b-c mt-10">
      <li>
        <a rel="noreferrer" :href="cgfOrGysEntryLink" title="采购人" target="_blank" class="flex-center cgr">
          <img src="@/assets/images/home/login-ico-cgr.png" alt="采购人">
          <span> 采购人 </span>
        </a>
      </li>
      <li>
        <a rel="noreferrer" :href="cgfOrGysEntryLink" title="供应商" target="_blank" class="flex-center gys">
          <img src="@/assets/images/home/login-ico-gys.png" alt="供应商">
          <span> 供应商 </span>
        </a>
      </li>
      <li>
        <a rel="noreferrer" :href="dljgEntryLink" title="代理机构" target="_blank" class="flex-center dljg">
          <img src="@/assets/images/home/login-ico-dljg.png" alt="代理机构">
          <span> 代理机构 </span>
        </a>
      </li>
      <li>
        <a rel="noreferrer" :href="pwEntryLink" title="专家" target="_blank" class="flex-center zj">
          <img src="@/assets/images/home/login-ico-zj.png" alt="专家">
          <span> 专家 </span>
        </a>
      </li>
      <li>
        <a rel="noreferrer" href="" title="监督部门" target="_blank" class="flex-center jdbm" @click.prevent="() =>dialogVisible = true">
          <img src="@/assets/images/home/login-ico-jdbm.png" alt="监督部门">
          <span> 监督部门 </span>
        </a>
      </li>
    </ul>
    <el-dialog
      title="选择相应系统登录"
      :visible.sync="dialogVisible"
      custom-class="login-entry-dialog"
      width="530px"
      top="25vh"
    >
      <div class="login-entry-pop f-c jdbm">
        <a rel="noreferrer" :href="jkjscEntryLink" title="监控驾驶舱" target="_blank" class="login-entry-pop-item mr-30">
          <h3>数字监管驾驶舱</h3>
          <div class="hover-txt-box f-b-c">
            <span>智能监控预警，赋能阳光采购业务发展。</span>
          </div>
        </a>
        <a rel="noreferrer" :href="dzbbEntryLink" title="电子报表" target="_blank" class="login-entry-pop-item">
          <h3>电子报表</h3>
          <div class="hover-txt-box f-b-c">
            <span>数字化记录采购数据，智能分析，优化决策。</span>
          </div>
        </a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "LoginEntry",
  components: {},
  props: {
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisibleKpb: false
    };
  },
  // 监听属性 类似于data概念
  computed: {
    dljgEntryLink() {
      return process.env.VUE_APP_ENTRY_DLJG_LINK
    },
    kbEntryLink() {
      return process.env.VUE_APP_ENTRY_KB_LINK
    },
    pbEntryLink() {
      return process.env.VUE_APP_ENTRY_PB_LINK
    },
    pwEntryLink() {
      return process.env.VUE_APP_ENTRY_PW_LINK
    },
    cgfOrGysEntryLink() {
      return process.env.VUE_APP_ENTRY_CGF_OR_GYS_LINK
    },
    dzbbEntryLink() {
      return process.env.VUE_APP_ENTRY_DZBB_LINK
    },
    jkjscEntryLink() {
      return process.env.VUE_APP_ENTRY_JKJSC_LINK
    }

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    noEntryClick() {
      this.$alert("敬请期待", "友情提示").catch(_ => {})
    }
  }
};
</script>

<style scoped lang="scss">
.login-entry{
	width: 281px;
	height: 289px;
	flex-shrink: 0;
	.login-entry-head{
		height: 30px;
		border-bottom: 1px solid #ddd;
		position: relative;
		line-height: 1;
		h3{
			font-size: 16px;
			font-weight: bold;
			color: #333;
		}
	}
  ul{
		flex-wrap: wrap;
    li{
      width: 135px;
      height: 70px;
      text-align: center;
			margin-top: 10px;
			&:hover{
				box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
			}
      &:nth-of-type(even){
        margin-left: 10px;
      }
			&:last-child{
				width: 100%;
			}
      a{
        width: 100%;
        height: 100%;
				font-size: 16px;
				color: #333;
				font-weight: bold;
				img {
					object-fit: contain;
					margin-right: 10px;
				}
        &.cgr{
					background-color: #FEF3ED;
					img{
						width: 28px;
						height: 29px;
					}
        }
        &.gys{
					background-color: #EDFDFC;
					img{
						width: 26px;
						height: 28px;
					}
        }
        &.dljg{
					background-color: #FFF3F3;
					img{
						width: 26px;
						height: 30px;
					}
        }
        &.zj{
					background-color: #F7EAFB;
					img{
						width: 24px;
						height: 25px;
					}
        }
        &.jdbm{
					background-color: #E5F1FF;
					img{
						width: 32px;
						height: 32px;
					}
        }
      }
    }
  }
}
.login-entry-pop{
  width: 100%;
  height: 340px;
  .login-entry-pop-item{
    width: 200px;
    height: 250px;
    display: block;
    position: relative;
    overflow: hidden;
    &:after{
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0;
      transition: opacity 0.4s;
      position: absolute;
      left: 0;
      top: 0;
    }
    h3{
      font-size: 18px;
      color: #fff;
      font-weight: bold;
      padding-left: 20px;
      position: absolute;
      left: 0;
      bottom: 40px;
      transition: transform 0.25s;
      &::after{
        content: '';
        display: block;
        width: 60px;
        height: 6px;
        border-radius: 3px;
        background-color: $--color-primary;
        position: absolute;
        left: 20px;
        bottom: 0;
        transform: translateY(15px);
      }
    }
    .hover-txt-box{
      width: 100%;
      height: 100%;
      //background-color: rgba(0,0,0,0.4);
      position: absolute;
      left: 0;
      top: 0;
      padding: 15px;
      transform: translateX(-100%);
      transition: transform 0.5s;
      z-index: 999;
      span{
        color: #fff;
        font-size: 14px;
        line-height: 1.5;
      }
    }
    &:hover{
      h3{
        transform: translateY(200px);
      }
      .hover-txt-box{
        transform: translateX(0);
      }
      &:after{
        opacity: 0.4;
      }
    }
  }
	&.kpb{
		> :first-child{
			background: url("@/assets/images/home/login-entry-pb.jpg") no-repeat center / cover;
		}
		> :last-child{
			background: url("@/assets/images/home/login-entry-kb.jpg") no-repeat center / cover;
		}
	}
	&.jdbm{
		> :first-child{
			background: url("@/assets/images/home/login-entry-jk.jpg") no-repeat center / cover;
		}
		> :last-child{
			background: url("@/assets/images/home/login-entry-bb.jpg") no-repeat center / cover;
		}
	}
}

::v-deep {
  .login-entry-dialog{
    .el-dialog__body{
      padding-top: 0;
    }
  }
}
</style>
